<template>
  <v-app>
    <Header />

    <v-main class="pt-6">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "Anlage-Grien-Belegungsplan",
  components: {
    Header,
  },

  data: () => ({
    //
  }),
};
</script>
